import BigNumber from 'bignumber.js'

import { CardBody, Flex, Text, CardRibbon } from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useTranslation } from 'contexts/Localization'
import { BIG_ZERO } from 'utils/bigNumber'
import { DeserializedPool } from 'state/types'
import { TokenImage, TokenPairImage } from 'components/TokenImage'
import { usePool } from 'state/pools/hooks'
import AprRow from './AprRow'
import { StyledCard } from './StyledCard'
import CardFooter from './CardFooter'
import PoolCardHeader, { PoolCardHeaderTitle } from './PoolCardHeader'
import CardActions from './CardActions'

const PoolCard: React.FC<{ pool: DeserializedPool; account: string }> = ({ pool, account }) => {
  const { sousId, stakingToken, earningToken, isFinished, userData } = pool
  const { t } = useTranslation()
  const stakedBalance = userData?.stakedBalance ? new BigNumber(userData.stakedBalance) : BIG_ZERO
  const accountHasStakedBalance = stakedBalance.gt(0)

  const normalPrice = Number(pool.busdPrice)
  const normalPriceBnb = new BigNumber(normalPrice / Number(pool.tokenPrice))
  const priceInUsd = pool.tokenPrice
    ? new BigNumber(pool.earningTokenPrice).times(new BigNumber(pool.tokenPrice.toString())).toNumber()
    : 0

  // const isCakePool = earningToken.symbol === 'HODLX' && stakingToken.symbol === 'HODLX'
  const discountRate = 1 - new BigNumber(pool.earningTokenPrice).div(normalPriceBnb).toNumber()

  const discountRatePercent =
    pool.discountRate !== undefined ? pool.discountRate.toString() : (Number(discountRate) * 100).toFixed(0)
  const discountSave = pool.busdPrice
    ? new BigNumber(pool.busdPrice.toString()).times(new BigNumber(discountRate))
    : BIG_ZERO

  return (
    <StyledCard
      isFinished={isFinished && pool.isBuyNFT !== true}
      ribbon={isFinished && <CardRibbon variantColor="textDisabled" text={t('Finished')} />}
    >
      <PoolCardHeader isStaking={accountHasStakedBalance} isFinished={isFinished && pool.isBuyNFT !== true}>
        <PoolCardHeaderTitle
          title={t('Buy Gem Fighter NFTs with BNB')}
          subTitle={t('Unlock P2E games and staking rewards')}
        />
        <TokenPairImage primaryToken={earningToken} secondaryToken={stakingToken} width={64} height={64} />
      </PoolCardHeader>
      <CardBody>
        <AprRow pool={pool} discountRatePercent={discountRatePercent} discountSave={discountSave} />
        <Flex alignItems="center" justifyContent="space-between">
          <Text>{`${t('Current ID:')}`}</Text>
          <Text>#{pool.tokenId ?? '-'}</Text>
        </Flex>
        {/* <Flex alignItems="center" justifyContent="space-between">
          <Text>{`${t('Current Earn $HODL APR:')}`}</Text>
          <Text>
            {pool.tokenId > 1800
              ? '200%'
              : pool.tokenId >= 1900
              ? '150%'
              : pool.tokenId >= 2150 && pool.tokenId < 2550
              ? '100%'
              : '0%'}
          </Text>
        </Flex> */}
        <Flex mt="24px" flexDirection="column">
          {account ? (
            <CardActions
              pool={pool}
              stakedBalance={stakedBalance}
              discountSave={new BigNumber(0)}
              busdPrice={priceInUsd}
            />
          ) : (
            <>
              <ConnectWalletButton />
            </>
          )}
        </Flex>
      </CardBody>
    </StyledCard>
  )
}

export default PoolCard
